module.exports = __webpack_public_path__ + "img/oldBuilding.5eec5e6b.png";